import React from 'react';
import ColorUtils from './ColorUtils';

const pallet = [
    "000000",
    "404040",
    "808080",
    "bfbfbf",
    "ffffff",
    "550000",
    "aa0000",
    "ff0000",
    "ff5555",
    "ffaaaa",
    "552c00",
    "aa5700",
    "ff8300",
    "ffac55",
    "ffd6aa",
    "555500",
    "aaa900",
    "fffe00",
    "fffe55",
    "ffffaa",
    "185500",
    "31aa00",
    "49ff00",
    "86ff55",
    "c2ffaa",
    "005531",
    "00aa61",
    "00ff92",
    "55ffb6",
    "aaffdb",
    "003155",
    "0061aa",
    "0092ff",
    "55b6ff",
    "aadbff",
    "180055",
    "3100aa",
    "4900ff",
    "8655ff",
    "c2aaff",
    "550049",
    "aa0092",
    "ff00db",
    "ff55e7",
    "ffaaf3",
];

interface Props {
    selectedColor: string | undefined,
    onClickColor: ((color: string) => void),
}

function YubinukiPallet(props: Props) {
    function handleClickColor(e: React.FormEvent<HTMLButtonElement>) {
        props.onClickColor(e.currentTarget.value);
    }

    let colorBoxes = pallet.map((color) => {
        return (
            <button key={color} type="button" name="color" className={ "btn buttonAction buttonColor mr-1 mb-1" + (color === props.selectedColor ? " btn-outline-secondary" : "")} value={color} onClick={handleClickColor}>
                <div className="colorBox" style={{ backgroundColor: ColorUtils.formatColor(color) }}></div>
            </button>
        )
    });

    return <div className="pallet">{colorBoxes}</div>
}

export default YubinukiPallet;
